import { ReactNode } from 'react';
import { useIsMounted } from '@toss/react';
import { useRouter } from 'next/router';
export const PageBlocker = ({
  children,
  fallbackUrl,
  condition
}: PageBlockerProps) => {
  const {
    replace
  } = useRouter();
  const isMounted = useIsMounted();
  if (!isMounted) return null;
  if (condition) {
    replace(fallbackUrl);
    return;
  }
  return <>{children}</>;
};
interface PageBlockerProps {
  children: ReactNode;
  fallbackUrl: string;
  condition: boolean;
}